import * as React from 'react';
import {
  css,
  genesisStyled,
  VisuallyHidden,
} from '@leagueplatform/genesis-commons';
import { useIntl } from '@leagueplatform/locales';
import {
  Button,
  Icon,
  StackLayout,
  Box,
  Modal,
} from '@leagueplatform/genesis-core';

const StyledModalContainer = genesisStyled(Modal.Content)(
  css({
    position: 'relative',
    borderRadius: 'medium',
    backgroundColor: 'surface.background.primary',
  }),
);

type ModalWrapperProps = {
  onClose: () => void;
  modalLabel: String;
  children: React.ReactChild;
  confirmButtonText?: String;
  onConfirmClick?: () => void;
  maxWidth?: string;
};

export const ModalWrapper = ({
  onClose,
  modalLabel,
  children,
  confirmButtonText,
  onConfirmClick = () => {
    onClose();
  },
  maxWidth = '380px',
}: ModalWrapperProps) => {
  const { formatMessage } = useIntl();

  return (
    <Modal.Root
      defaultOpen
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <StyledModalContainer
        onInteractOutside={onClose}
        showCloseButton={false}
        width={maxWidth}
        padding="$four $oneAndHalf $oneAndHalf"
        css={{
          '.GDS-modal': { position: 'fixed' },
        }}
      >
        <Modal.Title>
          <VisuallyHidden>{modalLabel}</VisuallyHidden>
        </Modal.Title>
        <Box css={{ position: 'absolute', right: '0', top: '0' }}>
          <Modal.Close>
            <Button
              css={{
                padding: '$half',
                margin: '$one',
              }}
              priority="secondary"
              quiet
            >
              <StackLayout>
                <VisuallyHidden>
                  {formatMessage({ id: 'CLOSE' })}
                </VisuallyHidden>
                <Icon icon="tinyClose" size={16} aria-hidden="true" />
              </StackLayout>
            </Button>
          </Modal.Close>
        </Box>
        <Box>
          {children}
          {confirmButtonText && (
            <Modal.Close>
              <Button
                priority="primary"
                onClick={onConfirmClick}
                css={{ marginTop: '$five' }}
              >
                {confirmButtonText}
              </Button>
            </Modal.Close>
          )}
        </Box>
      </StyledModalContainer>
    </Modal.Root>
  );
};
